module.exports = __webpack_public_path__ + "img/hip-ecto-mesomorph-female.c642e995.svg";